import { render, staticRenderFns } from "./SuppliersRegistryList.vue?vue&type=template&id=427e8b87"
import script from "./SuppliersRegistryList.vue?vue&type=script&lang=js"
export * from "./SuppliersRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports